module.exports = __webpack_public_path__ + "img/20200111125515774.78ff3c86.jpg";